import Backbone from '@polleverywhere/backbone'
import URI from 'urijs'

let instance

// @namespace Model
class Environment extends Backbone.Model {
  constructor (...args) {
    super(...args)

    // Return the singleton if it exists, otherwise create the instance
    if (!instance) {
      instance = this
      this.ios = this.ios.bind(this)
    }

    return instance
  }

  get defaults () {
    return {
      root_url: URI().host() ? `//${URI().host()}` : 'https://pollev.com',
      api_url: URI().host() ? `//${URI().host()}` : 'https://www.polleverywhere.com',
      viz_url: URI().host() ? `//${URI().host()}` : 'https://viz.polleverywhere.com',
      ssl: URI().protocol() === 'https:',
      firehose_url: '//firehose.polleverywhere.com',
      secure_protocol: 'https',
      image_url_regex: /^https?:\/\/.+\/[^/?]+\.(?:png|jpe?g|gif|image)\??\S*/i,
      image_file_regex: /^https?:\/\/.+\/([^/?]+\.(?:png|jpe?g|gif))\??\S*/i,
      uploaded_image_regex: /^https?:\/\/s3.amazonaws.com\/polleverywhere-images\/.*/i,
      image_bucket_url: 'https://upload-images.polleverywhere.com',
      poll_renderer_url: 'https://poll-renderer.polleverywhere.com',
      nginx_proxy_path: '',
      mobile_url: 'https://pollev.com',
      singularity_url: 'https://beta.polleverywhere.com',
      web_presenter_url: 'https://presenter.polleverywhere.com',
      /*
       * When enabled, Session will use a PPX proxy to get an auth token from
       * www.polleverywhere.com
       */
      token_auth_enabled: false
    }
  }

  get (key) {
    let val = super.get(key)

    if (val && /_url$/i.test(key)) {
      val = URI(val)
    }

    return val
  }

  ios () {
    return this.get('platform') === 'ios'
  }
}

export default Environment
